export default {
    url: '/competence',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/index.js